var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-container"},[_c('PWAModal'),_c('div',{staticClass:"header-and-body-container"},[_c('MenuVue'),_c('router-view')],1),_c('FooterIcons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }